<template>
  <div>
    <Row v-for="(item, index) in arr" :key="'select-group1-' + index">
      <Col span="22" class="select-sigle">
        <Select v-model="item.name" filterable placeholder="类别" @on-change="selectChange($event, index)">
          <Option v-for="item in type" :value="item.name" :key="item.name">{{ item.name }}</Option>
        </Select>
      </Col>
      <Col span="2" v-if="index===0" style="text-align:right;">
          <Icon
            type="ios-add-circle-outline"
            style="position: relative;top: 2px;font-size: 20px;cursor: pointer;color: #118eea;"
            @click="addGroup"
          />
        </Col>
        <Col span="2" v-else style="text-align:right;">
          <Icon
            type="ios-remove-circle-outline"
            style="position: relative;top: 2px;font-size: 20px;cursor: pointer;color: red;"
            @click="removeGroup(index)"
          />
        </Col>
    </Row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "category-filed-typeNew",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    Modal: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  data() {
    return {
      type: null,
      arr: [{name: ""}]
    };
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getCategoryByExhibitionList:
        "exhibitionModule/getCategoryByExhibitionList"
    }),
    async init() {
      let categoryData = await this.getCategoryByExhibitionList(
        this.exhibitionInfo.id
      );
      if (categoryData && categoryData.length) {
        this.type = categoryData;
      } else {
        this.type = [];
      }
      const copyData = JSON.parse(JSON.stringify(this.Modal));
      if (this.Modal) {
        if (this.Modal.length) {
          this.arr = [];
          this.type.forEach(c => {
            this.Modal.forEach(d => {
              if (c.id === d.Id) {
                this.arr.push(c);
              }
            })
          });
        }
      }
      if (this.arr.length === 0) {
        this.arr = [{name: ""}];
      } 
    },
    send() {
      let copyData = JSON.parse(JSON.stringify(this.arr));
      this.$emit("sendModal", copyData); 
    },
    selectChange(e,index) {
      let value1 = null;
      if (this.type && this.type.length) {
        this.type.forEach(c => {
          if (c.name === e) {
            value1 = JSON.parse(JSON.stringify(c));
            value1.list = [];
          }
        });
      }
      this.arr[index] = value1; 
      this.send();
    },
    close() {
      this.arr = [{name: ""}];
    },
    addGroup() {
      this.arr.push({name: ""});
    },
    removeGroup(idx) {
      this.arr.splice(idx, 1);
    }
  }
};
</script>

<style scoped lang="scss">
.select-group {
  .ivu-row {
    margin-top: 10px;
  }
  .select-sigle {
    padding-right: 10px;
  }
}
</style>

